import DashboardWrapper from 'modules/dashboard/components/DashboardWrapper';
import AIMaturityPage from 'modules/dashboard/ai-maturity/Main';
import EnterprisePortalPage from 'modules/dashboard/enterprise-portal/Main';
import PartnersHub from 'modules/dashboard/partners-hub/Main';
import MainOverviewPage from 'modules/dashboard/overviewv2/Main';
import NotificationPage from 'modules/notifications/NotificationPage';
import AIRiskBaseline from 'modules/dashboard/ai-risk-baseline/Main';
import AIRiskBaselineSurvey from 'modules/dashboard/ai-risk-baseline/components/AIRiskBaselineSurvey';
// import UserSecurityPage from 'modules/home/manage-clients/dashboard/usersettings/UserSecurityPage';

const DashboardRoutes = (): any => ({
  path: '',
  element: <DashboardWrapper />,
  children: [
    // {
    //   path: 'overview',
    //   element: <OverviewPage />,
    // },
    {
      path: 'overview',
      element: <MainOverviewPage />,
    },
    {
      path: 'ai-maturity',
      element: <AIMaturityPage />,
    },
    {
      path: 'enterprise-portal',
      element: <EnterprisePortalPage />,
    },
    {
      path: 'partners-hub',
      element: <PartnersHub />,
    },
    {
      path: 'notifications',
      element: <NotificationPage />,
    },
    {
      path: 'ai-risk-baseline',
      element: <AIRiskBaseline />,
    },
    {
      path: 'ai-risk-baseline/new',
      element: <AIRiskBaselineSurvey />,
    },
    {
      path: 'ai-risk-baseline/survey/:surveyId',
      element: <AIRiskBaselineSurvey />,
    },
  ],
});

export default DashboardRoutes;
